import React from 'react';

const Mobile = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <path d="M7.33331 5.33317C7.33331 3.86041 8.52722 2.6665 9.99998 2.6665H22C23.4727 2.6665 24.6666 3.86041 24.6666 5.33317V26.6665C24.6666 28.1393 23.4727 29.3332 22 29.3332H9.99998C8.52722 29.3332 7.33331 28.1393 7.33331 26.6665V5.33317ZM9.33331 5.33317V26.6665C9.33331 27.0347 9.63179 27.3332 9.99998 27.3332H22C22.3682 27.3332 22.6666 27.0347 22.6666 26.6665V5.33317C22.6666 4.96498 22.3682 4.6665 22 4.6665H18.9909C18.908 5.41657 18.2721 6 17.5 6H14.5C13.7279 6 13.092 5.41657 13.0091 4.6665H9.99998C9.63179 4.6665 9.33331 4.96498 9.33331 5.33317Z" />
  </svg>
);

export default Mobile;
